<script>
import { roundCloseButton } from "@project/theme-buttons.vue";
import { ModalPositionCenter } from "@kit/components/Modal.vue";

export const modal = {
  windowAutoPosition: true,
  position: ModalPositionCenter,
  backgroundClasses: "hta-modal-background",
  windowClasses: "hta-modal-window",
  closeButton: roundCloseButton,
};

export const scheduleModal = {
  windowAutoPosition: true,
  suspendScrolling: true,
  position: ModalPositionCenter,
  backgroundClasses: "hta-modal-background",
  windowClasses: "hta-modal-window",
  closeButton: roundCloseButton,
  headlineContainerClasses: { override: "sb sb-h sb-greedy-1" },
  innerClasses: { override: "sb sb-v sb-g10 sb-content-strict-height sb-greedy-1" },
};

export default { name: "theme-modal" };
</script>

<style>
.hta-modal-background {
  background-color: rgba(72, 114, 68, 0.7) !important;
}
.hta-modal-window {
  background: #ffffff;
  box-shadow: 6px 6px 5px rgb(55, 82, 52) !important;
  border-radius: 4px !important;
}
</style>
